import React from 'react';
import { Wrapper, AdventCalendarDoors } from '@crossroads/ui-components';
import { useTranslate } from '@awardit/react-use-translate';
import { useData } from 'crustate/react';
import { Helmet } from 'react-helmet-async';
import { AdventCalendarHero } from '../../components/AdventCalendarHero/index.js';
import { Today } from '../../components/AdventCalendarToday/index.js';
import cn from 'classnames';
import styles from 'shop-views/AdventCalendar.scss';

var Closed = _ref => {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("span", null, text);
};

var RegisterHero = _ref2 => {
  var _categoryImage$clsCat;

  var _ref2$isFullHeight = _ref2.isFullHeight,
      isFullHeight = _ref2$isFullHeight === void 0 ? false : _ref2$isFullHeight,
      _ref2$isHomeView = _ref2.isHomeView,
      isHomeView = _ref2$isHomeView === void 0 ? false : _ref2$isHomeView,
      categoryImage = _ref2.categoryImage,
      subscribe = _ref2.subscribe,
      RegisterFormComponent = _ref2.RegisterFormComponent;
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.landing, {
      [styles.fullHeight]: isFullHeight
    }),
    style: categoryImage ? {
      backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3),
    rgba(0, 0, 0, 0.1)), url(${((_categoryImage$clsCat = categoryImage.clsCatfieldsGeneralImgL) == null ? void 0 : _categoryImage$clsCat.x2) || ""})`
    } : {}
  }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    className: cn(styles.landingContainer, {
      [styles.homeView]: isHomeView
    })
  }, /*#__PURE__*/React.createElement(RegisterFormComponent, {
    className: styles.registerForm,
    homeView: isHomeView,
    subscriptionStatus: subscribe
  }))));
};
var AdventCalendarView = _ref3 => {
  var _home$data$adventCale;

  var calendarData = _ref3.calendarData,
      homeData = _ref3.homeData,
      ProductListComponent = _ref3.ProductListComponent,
      LoadingView = _ref3.LoadingView,
      _ref3$hasAdventCalend = _ref3.hasAdventCalendarHero,
      hasAdventCalendarHero = _ref3$hasAdventCalend === void 0 ? false : _ref3$hasAdventCalend,
      _ref3$hasAlternativeL = _ref3.hasAlternativeLayout,
      hasAlternativeLayout = _ref3$hasAlternativeL === void 0 ? false : _ref3$hasAlternativeL,
      subscribe = _ref3.subscribe,
      _ref3$hasRegisterForm = _ref3.hasRegisterFormFunctionality,
      hasRegisterFormFunctionality = _ref3$hasRegisterForm === void 0 ? false : _ref3$hasRegisterForm,
      RegisterFormComponent = _ref3.RegisterFormComponent,
      _ref3$buttonVariantTo = _ref3.buttonVariantToday,
      buttonVariantToday = _ref3$buttonVariantTo === void 0 ? "ghost" : _ref3$buttonVariantTo,
      _ref3$buttonVariantDo = _ref3.buttonVariantDoors,
      buttonVariantDoors = _ref3$buttonVariantDo === void 0 ? "negative" : _ref3$buttonVariantDo;
  var t = useTranslate();
  var home = useData(homeData);
  var calendar = useData(calendarData);
  var categoryImage = hasRegisterFormFunctionality && home.state === "LOADED" && ((_home$data$adventCale = home.data.adventCalendar) == null ? void 0 : _home$data$adventCale.category) !== undefined && home.data.adventCalendar.category.clsCatfieldsGeneralImgL !== null ? home.data.adventCalendar.category : null;

  if (calendar.state !== "LOADED") {
    return typeof LoadingView === "function" ? /*#__PURE__*/React.createElement(LoadingView, null) : null;
  }

  var today = null;
  calendar.data.forEach(day => {
    if (day.__typename === "AdventCalendarDoorToday") {
      today = day;
    }
  });
  var openDays = [];
  calendar.data.forEach(day => {
    if (day.__typename !== "AdventCalendarDoorLocked") {
      openDays.push(day);
    }
  });

  if (openDays.length === 0) {
    var _categoryImage$clsCat2;

    return /*#__PURE__*/React.createElement("div", {
      className: cn(styles.landing, styles.fullSize),
      style: categoryImage && hasRegisterFormFunctionality ? {
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3),
          rgba(0, 0, 0, 0.1)), url(${((_categoryImage$clsCat2 = categoryImage.clsCatfieldsGeneralImgL) == null ? void 0 : _categoryImage$clsCat2.x2) || ""})`
      } : {}
    }, /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
      className: styles.landingContainer
    }, hasRegisterFormFunctionality && RegisterFormComponent ? /*#__PURE__*/React.createElement(RegisterFormComponent, {
      className: styles.registerForm,
      subscriptionStatus: subscribe
    }) : /*#__PURE__*/React.createElement("div", {
      className: styles.text
    }, /*#__PURE__*/React.createElement("h1", null, t("ADVENT_CALENDAR.LANDING.HEADING")), /*#__PURE__*/React.createElement("p", null, t("ADVENT_CALENDAR.LANDING.TEXT"))))));
  }

  return /*#__PURE__*/React.createElement("div", {
    className: styles.block
  }, /*#__PURE__*/React.createElement(Helmet, {
    title: t("ADVENT_CALENDAR.TEXT")
  }), hasRegisterFormFunctionality && RegisterFormComponent ? /*#__PURE__*/React.createElement(RegisterHero, {
    categoryImage: categoryImage,
    subscribe: subscribe,
    RegisterFormComponent: RegisterFormComponent
  }) : null, hasAdventCalendarHero && /*#__PURE__*/React.createElement(AdventCalendarHero, {
    hasAlternativeHeroLayout: true,
    category: null,
    home: home.state === "LOADED" ? home.data : {}
  }), openDays.length > 0 && today && /*#__PURE__*/React.createElement(Today, {
    door: today,
    home: home,
    hasAlternativeLayout: hasAlternativeLayout,
    ProductListComponent: ProductListComponent,
    buttonVariant: buttonVariantToday
  }), /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement(AdventCalendarDoors, {
    closedSlot: /*#__PURE__*/React.createElement(Closed, {
      text: t("ADVENT_CALENDAR.CALENDAR_CLOSED")
    }),
    doors: calendar.data,
    buttonVariant: buttonVariantDoors
  })));
};

export { AdventCalendarView, RegisterHero };
//# sourceMappingURL=index.js.map
